import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  TrackByFunction,
  ViewEncapsulation
} from '@angular/core';
import { WorkItemIntegration } from 'common/store/genesys-cloud/work-item-integrations/models/work-item-integrations.model';
import { WorkAreaManager } from 'common/workitems/work-area-manager.service';

@Component({
  selector: 'app-genesys-lane-buttons',
  templateUrl: './genesys-lane-buttons.component.html',
  styleUrls: ['./genesys-lane-buttons.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenesysLaneButtonsComponent {
  @Input()
  integrations: WorkItemIntegration[];
  @Input()
  openIntegrationPanels: WorkItemIntegration[];
  @Input()
  isCobrowseAllowed: boolean;
  @Input()
  isCobrowseActive: boolean;
  @Output()
  readonly toggleCobrowse = new EventEmitter<string>();
  @Output()
  readonly toggleIntegration = new EventEmitter<string>();

  constructor(private readonly workAreaManager: WorkAreaManager) {}

  isActive(id: string): boolean {
    return this.openIntegrationPanels.some((integration) => integration.id === id);
  }

  get currentWorkItemId(): string {
    return this.workAreaManager.getSelectedWorkItem()?.id;
  }

  readonly trackIntegrations: TrackByFunction<WorkItemIntegration> = (_index: number, item: WorkItemIntegration) =>
    item.id;
}
